module.exports = __webpack_public_path__ + "images/guide-dark.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guide-dark.png
// module id = 1058
// module chunks = 17